import React from "react";
import { Helmet } from 'react-helmet-async';
import "./Liturgy.css";
import { day, sunday, liturgyImage } from "../../data/liturgyData.js"; 
import Invitation from "../../components/Invitation/Invitation.js";

const Liturgy = () => {
  const getSundayHours = () => {
    return sunday.map(item => `${item.hour}${item.info ? ` (${item.info})` : ''}`).join(', ');
  };

  const getWeekdayHours = () => {
    return day.map(item => `${item.hour}${item.info ? ` (${item.info})` : ''}`).join(', ');
  };

  const getMetaDescription = () => {
    const sundayHours = getSundayHours();
    const weekdayHours = getWeekdayHours();
    return `Godziny mszy świętych w parafii św. Urszuli Ledóchowskiej w Częstochowie. Niedziele: ${sundayHours}. Dni powszednie: ${weekdayHours}. Zapraszamy na mszę św.!`;
  };

  return (
    <>
      <Helmet>
        <title>Msze Święte – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content={getMetaDescription()} />
        <meta name="keywords" content="msze święte, godziny mszy, niedziela msza, tydzień msze, parafia Częstochowa, św. Urszula Ledóchowska, Wrzosowiak, msze parafialne" />
        <meta property="og:title" content="Msze Święte – Parafia św. Urszuli Ledóchowskiej" />
        <meta property="og:description" content={`Godziny mszy św. w parafii św. Urszuli Ledóchowskiej. Niedziele: ${getSundayHours()}. Dni powszednie: ${getWeekdayHours()}.`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/msze-swiete" />
        <meta property="og:image" content={liturgyImage} />
        <meta property="og:image:alt" content="Kościół św. Urszuli Ledóchowskiej w Częstochowie" />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Msze Święte – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content={`Msze św. w parafii św. Urszuli Ledóchowskiej. Sprawdź godziny: niedziele ${getSundayHours()}, dni powszednie ${getWeekdayHours()}.`} />
        <meta name="twitter:image" content={liturgyImage} />
      </Helmet>

      <section>
        <div className="liturgy-card">
          <img
            src={liturgyImage}
            alt="Kościół parafialny św. Urszuli Ledóchowskiej w Częstochowie"
            className="image"
          />

          <h2 className="liturgy-title">Msze Święte</h2>

          <p>
            w niedzielę:&nbsp;
            {sunday.map((item, index) => (
              <span key={index}>
                <b>{item.hour}</b>
                {item.info && ` ${item.info}`}
                {index < sunday.length - 1 && ", "}
              </span>
            ))}
          </p>

          <p>
            w tygodniu:&nbsp;
            {day.map((item, index) => (
              <span key={index}>
                <b>{item.hour}</b>
                {item.info && ` ${item.info}`}
                {index < day.length - 1 && ", "}
              </span>
            ))}
          </p>
        </div>
        <Invitation/>
      </section>
    </>
  );
};

export default Liturgy;